/**
 * 正则校验工具
 */
var myfunction = {
  checkNubmer(value) {
    const pattern = /^[0-9]*$/
    return pattern.test(value)
  },
  checkDecimalNubmer(value) {
    const pattern = /^[0-9]*\.([0-9]*)$/
    return pattern.test(value)
  },
  checkEmail(value) {
    const pattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value)
  },
}

export default myfunction
